@if (visible()) {
<div class="sub-toast" [class.sub-toast--expired]="expired()" [class.sub-toast--promo]="promo()" role="dialog"
    aria-labelledby="sub-toast-title" [attr.data-testid]="promo() ? 'promo_toast' : 'card-preauth_toast'">
    <div class="sub-toast__head">
        @if (promo()) {
        <div class="sub-toast__eyebrow sub-toast__eyebrow--promo">
            <svg class="sub-toast__gift" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="3" y="8" width="18" height="4" rx="1" />
                <path d="M12 8v13" />
                <path d="M19 12v9H5v-9" />
                <path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5" />
            </svg>{{ p('payment.promo.toast.eyebrow') }}
        </div>
        } @else if (expired()) {
        <div class="sub-toast__eyebrow"><span class="sub-toast__dot"></span>{{ t('payment.card_preauth.header.expired') }}</div>
        } @else {
        <svg class="sub-toast__warn" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <path d="M12 9v4" />
            <path d="M12 17h.01" />
        </svg>
        }
        <h3 id="sub-toast-title" [attr.data-testid]="promo() ? 'promo_toast-title' : 'card-preauth_toast-title'">{{ title() }}</h3>
    </div>
    <p [attr.data-testid]="promo() ? 'promo_toast-text' : 'card-preauth_toast-text'">{{ text() }}</p>
    <div class="sub-toast__actions">
        <button type="button" class="btn-ghost" (click)="later()"
            [attr.data-testid]="promo() ? 'promo_toast-later' : 'card-preauth_toast-later'">
            {{ t('common.not_now') }}</button>
        <button type="button" class="btn-primary" (click)="confirm()"
            [attr.data-testid]="promo() ? 'promo_toast-confirm' : 'card-preauth_toast-confirm'">
            {{ confirmLabel() }}</button>
    </div>
</div>
}
